/* Grounded Fox – Fade ONLY mega menu on scroll down */
(function () {
  const header = document.querySelector(".section-header");
  if (!header) return;

  let lastY = window.scrollY || 0;
  let ticking = false;
  let closeTimeout = null;

  function fadeAndCloseMegaMenu() {
    const openDetails = header.querySelectorAll(".header__inline-menu details[open]");

    openDetails.forEach((details) => {
      const panel = details.querySelector(".mega-menu__content");
      if (!panel) {
        details.removeAttribute("open");
        return;
      }

      /* If already fading, do nothing */
      if (panel.classList.contains("gf-mega-hide")) return;

      panel.classList.add("gf-mega-hide");

      /* Close AFTER the fade completes */
      clearTimeout(closeTimeout);
      closeTimeout = setTimeout(() => {
        details.removeAttribute("open");
        panel.classList.remove("gf-mega-hide");
      }, 560); // slightly longer than CSS transition
    });
  }

  function clearFadeState() {
    header.querySelectorAll(".mega-menu__content.gf-mega-hide").forEach((el) => {
      el.classList.remove("gf-mega-hide");
    });
  }

  function onScroll() {
    const y = window.scrollY || 0;

    const nearTop = y < 60;
    const scrollingDown = y > lastY + 8;
    const scrollingUp = y < lastY - 4;

    if (scrollingDown && !nearTop) {
      fadeAndCloseMegaMenu();
    }

    /* If user scrolls up, cancel any fade state so it feels responsive */
    if (scrollingUp || nearTop) {
      clearFadeState();
    }

    lastY = y;
    ticking = false;
  }

  window.addEventListener(
    "scroll",
    function () {
      if (!ticking) {
        requestAnimationFrame(onScroll);
        ticking = true;
      }
    },
    { passive: true }
  );
})();
